// Contenuti e configurazione Palumbo Academy (segnaposto — aggiornabili)
import {
  GraduationCap, ListChecks, ArrowRightLeft, MapPinned, RefreshCcw,
  Award, Trophy, LineChart, CreditCard, HandCoins, FileText, Scale,
  BookOpen, Building2, Users, ShieldCheck, Landmark, Briefcase
} from "lucide-react";

export const CONFIG = {
  brand: "Palumbo Academy",
  tagline: "Sindacato Scuola",
  phone: "342 984 6258",
  phoneHref: "tel:3429846258",
  whatsapp: "393429846258",
  whatsappMsg: "Buongiorno, desidero ricevere informazioni sui servizi di Palumbo Academy.",
  email: "consulenza.dirittiscuola@gmail.com",
  goldieUrl: "https://www.goldie.it",
  piva: "P.IVA / C.F. 00000000000",
  social: {
    facebook: "https://facebook.com",
    instagram: "https://instagram.com",
    youtube: "https://youtube.com",
  },
};

export const whatsappLink = () =>
  `https://wa.me/${CONFIG.whatsapp}?text=${encodeURIComponent(CONFIG.whatsappMsg)}`;

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Chi siamo", to: "/chi-siamo" },
  { label: "Servizi", to: "/servizi" },
  { label: "Formazione", to: "/formazione" },
  { label: "News", to: "/news" },
  { label: "Scadenziario", to: "/scadenziario" },
  { label: "Contatti", to: "/contatti" },
];

export const ACTIVITIES = [
  { icon: GraduationCap, title: "GPS e graduatorie" },
  { icon: ListChecks, title: "150 preferenze" },
  { icon: ArrowRightLeft, title: "Mobilità" },
  { icon: MapPinned, title: "Assegnazioni provvisorie" },
  { icon: Briefcase, title: "Utilizzazioni" },
  { icon: Landmark, title: "Immissioni in ruolo" },
  { icon: Trophy, title: "Concorsi scuola" },
  { icon: LineChart, title: "Ricostruzione di carriera" },
  { icon: CreditCard, title: "Carta del docente" },
  { icon: HandCoins, title: "NASpI" },
  { icon: FileText, title: "CAF e Patronato" },
  { icon: Scale, title: "Ricorsi" },
  { icon: BookOpen, title: "Formazione e certificazioni" },
];

export const SERVICES = [
  {
    id: "gps",
    icon: GraduationCap,
    title: "GPS e Graduatorie",
    desc: "Assistenza completa per inserimento, aggiornamento, scioglimento della riserva, scelta delle province, valutazione dei titoli e verifica del punteggio.",
  },
  {
    id: "150-preferenze",
    icon: ListChecks,
    title: "150 Preferenze",
    desc: "Supporto nella compilazione della domanda per le supplenze annuali e fino al termine delle attività didattiche, con analisi delle preferenze, disponibilità, spezzoni, COE e posto orario.",
  },
  {
    id: "mobilita",
    icon: ArrowRightLeft,
    title: "Mobilità",
    desc: "Consulenza per trasferimenti, passaggi di ruolo, passaggi di cattedra, precedenze, vincoli e individuazione delle preferenze.",
  },
  {
    id: "assegnazioni",
    icon: MapPinned,
    title: "Assegnazioni Provvisorie e Utilizzazioni",
    desc: "Assistenza nella verifica dei requisiti e nella compilazione delle domande di assegnazione provvisoria e utilizzazione.",
  },
  {
    id: "concorsi",
    icon: Trophy,
    title: "Concorsi Scuola",
    desc: "Supporto per la partecipazione ai concorsi, valutazione dei titoli, scelta della regione, preparazione delle domande e verifica delle graduatorie.",
  },
  {
    id: "immissioni",
    icon: Landmark,
    title: "Immissioni in Ruolo",
    desc: "Assistenza nelle procedure telematiche, scelta della provincia, scelta della sede e verifica della documentazione.",
  },
  {
    id: "ricostruzione",
    icon: LineChart,
    title: "Ricostruzione di Carriera",
    desc: "Consulenza per ricostruzione di carriera, riallineamento, scatti stipendiali e rapporti con Ragioneria Territoriale e amministrazioni scolastiche.",
  },
  {
    id: "naspi",
    icon: HandCoins,
    title: "NASpI",
    desc: "Assistenza per la presentazione della domanda di disoccupazione, verifica dei requisiti e gestione della documentazione.",
  },
];

export const CAF_SERVICES = [
  "ISEE", "Modello 730", "Bonus", "Assegno unico", "Domande pensionistiche",
  "Invalidità", "Maternità", "Congedi", "Disoccupazione", "Prestazioni INPS",
];

export const FORMAZIONE = [
  "Corsi abilitanti",
  "Percorsi 30, 36 e 60 CFU",
  "TFA sostegno",
  "Percorsi INDIRE",
  "Master",
  "CLIL",
  "Certificazioni informatiche",
  "Certificazioni linguistiche",
  "Corsi per personale ATA",
  "Corsi per aumentare il punteggio",
];

export const POLI = [
  { name: "Polo Didattico eCampus", icon: Building2 },
  { name: "Polo Didattico Link Campus", icon: Building2 },
  { name: "British Institute", icon: BookOpen },
  { name: "Certificazioni linguistiche", icon: Award },
  { name: "Certificazioni informatiche", icon: ShieldCheck },
];

export const NEWS_CATEGORIES = [
  "Tutte", "GPS", "Mobilità", "Assegnazioni provvisorie", "Concorsi",
  "Immissioni in ruolo", "NASpI", "CAF e Patronato", "Formazione",
  "Carta del docente", "Personale ATA", "Docenti",
];

export const SEDI = [
  {
    city: "Cosenza",
    address: "Via Giuseppe Isnardi 33, Cosenza (CS).",
    map: "https://maps.google.com/?q=Via+Giuseppe+Isnardi+33+Cosenza",
  },
  {
    city: "Fiumefreddo Bruzio",
    address: "Polo Didattico eCampus.",
    map: "https://maps.google.com/?q=Fiumefreddo+Bruzio",
  },
  {
    city: "Corigliano-Rossano",
    address: "Via Papa Giovanni XXIII, 20, interno 18, piano terra.",
    map: "https://maps.google.com/?q=Via+Papa+Giovanni+XXIII+20+Corigliano-Rossano",
  },
];

export const SEDI_OPTIONS = [
  "Cosenza", "Fiumefreddo Bruzio", "Corigliano-Rossano", "Consulenza online",
];

export const FASCE_ORARIE = [
  "09:00 - 11:00", "11:00 - 13:00", "15:00 - 17:00", "17:00 - 19:00",
];

export const TESTIMONIALS = [
  { name: "Maria R.", role: "Docente scuola primaria", text: "Grazie a Palumbo Academy ho aggiornato la mia posizione in GPS senza errori. Professionalità e disponibilità straordinarie." },
  { name: "Giuseppe L.", role: "Personale ATA", text: "Mi hanno seguito passo passo nella domanda di mobilità. Consulenza chiara, puntuale e sempre reperibile." },
  { name: "Antonella S.", role: "Docente di sostegno", text: "Ottima assistenza per il TFA sostegno e per le certificazioni. Un punto di riferimento serio per la scuola." },
  { name: "Francesco P.", role: "Aspirante docente", text: "Ho presentato la domanda di concorso con la loro guida. Precisi, competenti e umani. Consigliatissimi." },
];

export const FAQ = [
  { q: "Come posso prenotare un appuntamento?", a: "Puoi prenotare direttamente dal sito compilando il modulo nella pagina 'Prenota appuntamento', scegliendo servizio, sede e fascia oraria. In alternativa puoi contattarci via telefono o WhatsApp." },
  { q: "Quale documentazione devo portare?", a: "La documentazione varia in base al servizio richiesto. Al momento della prenotazione e durante il primo contatto ti indicheremo con precisione tutti i documenti necessari per la tua pratica." },
  { q: "Seguite tutte le procedure scolastiche?", a: "Sì. Offriamo assistenza per GPS, 150 preferenze, mobilità, assegnazioni provvisorie, utilizzazioni, immissioni in ruolo, concorsi, ricostruzione di carriera e molto altro." },
  { q: "Come funzionano i pagamenti?", a: "Le modalità di pagamento vengono comunicate in fase di consulenza in base al servizio scelto. Garantiamo trasparenza totale sui costi prima dell'avvio di ogni pratica." },
  { q: "È possibile fare consulenza online?", a: "Certamente. Tra le sedi disponibili puoi selezionare 'Consulenza online' e verrai seguito da remoto con la stessa attenzione della consulenza in sede." },
  { q: "Come carico i documenti della mia pratica?", a: "Gli assistiti registrati potranno caricare documenti in formato PDF e immagini direttamente dall'Area Riservata, in modo sicuro e protetto." },
  { q: "Come accedo all'Area Riservata?", a: "L'Area Riservata è accessibile con email e password. Le credenziali vengono fornite dopo l'attivazione della pratica presso una delle nostre sedi." },
];

export const PRATICA_STATI = [
  { label: "Documentazione da completare", color: "bg-amber-100 text-amber-800" },
  { label: "Documentazione ricevuta", color: "bg-sky-100 text-sky-800" },
  { label: "Pratica in lavorazione", color: "bg-indigo-100 text-indigo-800" },
  { label: "Pratica inoltrata", color: "bg-violet-100 text-violet-800" },
  { label: "Pratica completata", color: "bg-emerald-100 text-emerald-800" },
  { label: "Necessario contatto telefonico", color: "bg-rose-100 text-rose-800" },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1523240795612-9a054b0db644?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  consulting: "https://images.unsplash.com/photo-1758691463333-c79215e8bc3b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  consulting2: "https://images.unsplash.com/photo-1758691462878-6edc3d3da1be?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  training: "https://images.unsplash.com/photo-1511629091441-ee46146481b6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  classroom: "https://images.unsplash.com/photo-1740635341299-3b8e3490f546?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};
